export const Identity_Platform = {
  CIP: 'ForgeRock',
  AAD: 'AzureAuthentication'
}
